"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSelfEmployedData = exports.selfEmployedFormRules = exports.selfEmployedSchema = void 0;
const converters_1 = require("../../converters");
const income_1 = require("./income");
exports.selfEmployedSchema = {
    fields: {
        ...income_1.incomeSchema.fields,
    },
    messages: {
        ...income_1.incomeSchema.messages,
        institution_name: {
            maxLength: 'Type of Business must be 200 characters or less',
        },
        contact_name: {
            maxLength: 'Accountant Name must be 50 character or less',
        },
    },
};
// 🚀 Pre-computed validations for performance
exports.selfEmployedFormRules = (0, converters_1.toReactHookForm)(exports.selfEmployedSchema, income_1.incomeFieldMapping);
exports.validateSelfEmployedData = (0, converters_1.createValidator)(exports.selfEmployedSchema);
